import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Cell } from '@/components/home/PopularSearches/Cell';
import { IPopularSearch } from '@/api/home/types';
import { NextLink } from '@/components/blocks/NextLink';
import { Routes } from '@/routes';

// "POPULAR SEARCHES" caption with a rule extending left and right of the
// text — uses ::before/::after pseudo elements pinned to 100% width via
// negative margins. Replicating the trick inline with two flex children.
const titleClass = [
  'flex items-center justify-center overflow-hidden mb-5',
  'uppercase tracking-[0.065em] text-white text-[2rem] text-center',
  'max-md:hidden',
  "before:content-[''] before:block before:flex-1 before:h-px before:bg-white before:opacity-40 before:mr-4",
  "after:content-[''] after:block after:flex-1 after:h-px after:bg-white after:opacity-40 after:ml-4",
].join(' ');

const gridClass = [
  'grid grid-cols-3 grid-rows-2 gap-px',
  'rounded-md overflow-hidden',
  'max-md:grid-cols-2 max-md:grid-rows-3',
].join(' ');

const wrapperClass = [
  'mx-auto w-3/5',
  'max-xl:w-full',
].join(' ');

const lastCellClass = [
  'group flex min-h-[50px] items-center justify-center cursor-pointer',
  'bg-white opacity-[0.85] border-0 appearance-none',
  'hover:opacity-100',
  'max-md:basis-[49%] max-md:min-h-[45px]',
].join(' ');

const lastQueryClass = [
  'flex items-center justify-center h-[50px] min-w-[50px]',
  'text-sm leading-[1.275rem] font-normal text-[#304769] opacity-90',
  'group-hover:text-primary group-hover:font-semibold',
].join(' ');

export const PopularSearches = ({ popularSearch }: { popularSearch: IPopularSearch }) => {
  const { t } = useOTSTranslation('common');

  return (
    <section className={wrapperClass}>
      <span className={titleClass}>
        {t('homePage.popularSearches')}
      </span>
      <div className={gridClass}>
        {
          popularSearch.results.slice(0, 5).map((item) => (
            <Cell
              key={typeof item === 'string' ? item : item.uuid}
              query={item}
            />
          ))
        }
        <NextLink
          href={Routes.nearbyResorts()}
          type="button"
          className={lastCellClass}
        >
          <div className={lastQueryClass}>{t('homePage.nearbyResorts')}</div>
        </NextLink>
      </div>
    </section>
  );
};
